import { render, staticRenderFns } from "./detectionForm.vue?vue&type=template&id=160e7c67&scoped=true"
import script from "./detectionForm.vue?vue&type=script&lang=js"
export * from "./detectionForm.vue?vue&type=script&lang=js"
import style0 from "./detectionForm.vue?vue&type=style&index=0&id=160e7c67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160e7c67",
  null
  
)

export default component.exports